import { motion } from "framer-motion"

interface AnimatedEmojiProps {
  emoji: string
  className?: string
}

const gpuLayerStyle = {
  willChange: "transform",
  backfaceVisibility: "hidden" as const,
}

export default function AnimatedEmoji({
  emoji,
  className = "text-5xl",
}: AnimatedEmojiProps) {
  return (
    <motion.div
      initial={{ scale: 0.01, rotate: -180, opacity: 0 }}
      animate={{ scale: 1, rotate: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 200, damping: 15 }}
      style={gpuLayerStyle}
    >
      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className={`emoji ${className}`}
        style={gpuLayerStyle}
      >
        {emoji}
      </motion.div>
    </motion.div>
  )
}
